<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 お問い合わせ
        v-layout.py-4.white_container.justify-center(row wrap)
          v-form(style='width: 80%;')
            p.mt-3 *印は必須項目です。
            v-layout(row)
              v-flex(xs12)
                v-subheader お問い合わせ項目を選択してください*
                v-radio-group(v-model="contact.type" :rules="[rules.required]" hide-details)
                  v-radio(v-for="radio in radios" :key="radio.value" :label="radio.label" :value="radio.value")
            v-layout(row)
              v-flex(xs12 md12)
                v-subheader お問い合せ内容をご入力ください。*
                v-textarea.mt-3(label="お問い合せ内容" outline rows="5" v-model="contact.contents" ref="contents" :rules="[rules.required]")
            v-layout(row)
              v-flex(xs12 md12)
                v-subheader お客様情報をご入力ください
                v-text-field(label="お名前*" v-model="contact.name" prepend-icon="face" ref="name" :rules="[rules.required]")
                v-text-field(label="E-mail*" v-model="contact.email" prepend-icon="mail" ref="email" :rules="[rules.required,rules.email]")
                v-text-field(label="お電話番号" v-model="contact.tel" prepend-icon="phone" hint="（例：025-275-8185,0252758185 半角数字)")
            v-layout.mt-5
              v-flex(md4 offset-md4)
                v-btn(@click="sendContact" color="primary" round block outline :disabled="exclusiveLock")
                  span 送信する
            v-layout(row).mt-5.justify-center
              img(src="/static/images/contact_mrs_kosuzume.png" alt='ご感想もぜひ聞かせてください' width=200 height=145)
    CommonFooter
</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'
import rules from '@/common/mixins/rules'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.error = '#9e5d0d'
    this.$vuetify.theme.accent = '#9e5d0d'
  },
  data () {
    return {
      radios: [
        {
          label: '商品について',
          value: 1
        }, {
          label: 'ご注文・お支払い・配送方法について',
          value: 2
        }, {
          label: 'その他',
          value: 3
        }
      ],
      contact: {
        type: 1,
        name: '',
        email: '',
        contents: '',
        tel: ''
      },
      exclusiveLock: false
    }
  },
  mixins: [rules],
  methods: {
    sendContact () {
      if (this.hasRuleError()) {
        this.$toastr.warning('入力に不備があります。')
        return true
      }
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true
      this.$ajax.post('/resources/contacts', this.contact)
        .then((response) => {
          this.$router.push(`/contact_danke/${response.data.id}`)
        })
        .catch((response) => {
          this.$toastr.error('通信時に問題が発生しました。大変お手数ですが、時間をおいてやりなおしていただくか、弊社までご連絡いただきますよう、お願い致します。')
          console.dir(response)
        })
        .finally(() => {
          this.exclusiveLock = false
        })
    }
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc

.v-subheader
  font-size 1rem
  font-weight bold
  margin 1rem 0 0 -1rem
  color $color-primary
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Contact/index.vue